// extracted by mini-css-extract-plugin
export default {"toolbar":"PageToolbar_toolbar__57oxr","left":"PageToolbar_left__fETQm","right":"PageToolbar_right__vOfnt"};